module.exports = "<div class=\"faq-entry row-fluid\">\r\n    <div class=\"btn toggler\">\r\n        <div class=\"btn btn-small\">\r\n            <i class=\"icon-chevron-up\" />\r\n            <i class=\"icon-chevron-down\" />\r\n        </div>\r\n        <span></span>\r\n    </div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/faq/faqEntryView.html
 ** module id = 39
 ** module chunks = 0
 **/